import React, { useState } from 'react';
import { Chip, Menu, MenuItem } from '@material-ui/core';
import { CourierType } from 'const/CourierType';
import { FaMap, FaRandom, FaTrash } from 'react-icons/fa';
import './CourierChip.scss';
import { uniqueId } from 'lodash';
import { Link } from 'react-router-dom';

interface CourierChipProps {
  courier: CourierType;
  onRemoveFromPartition?: (courier: CourierType) => void;
  onReassignToActivePartition?: (courier: CourierType) => void;
  onCourierHoverChange?: (couriers?: CourierType[]) => void;
}

export const CourierChip = ({ courier, ...props }: CourierChipProps) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const courierIdentifier = courier?.id || uniqueId();

  const onChipClicked = evt => {
    setOpenMenu(true);
    setAnchorEl(evt.currentTarget);
  };

  const onMenuClosed = () => {
    setOpenMenu(false);
    setAnchorEl(null);
  };

  const onRemoveClicked =
    props.onRemoveFromPartition &&
    (() => {
      props.onRemoveFromPartition(courier);
      onMenuClosed();
    });

  const onReassignClicked = () => {
    props.onReassignToActivePartition(courier);
    onMenuClosed();
  };

  return (
    <div
      className="courier-chip"
      id={`courier-chip-${courierIdentifier}`}
      onMouseEnter={() => props.onCourierHoverChange([courier])}
      onMouseLeave={() => props.onCourierHoverChange(undefined)}
    >
      <Chip
        label={`${courier?.name} (${courier?.id})`}
        variant="outlined"
        onClick={onChipClicked}
        onDelete={onRemoveClicked}
        aria-controls={openMenu ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openMenu ? 'true' : undefined}
      />
      <Menu
        className="courier-chip-menu"
        open={openMenu}
        anchorEl={anchorEl}
        elevation={0}
        MenuListProps={{
          'aria-labelledby': `courier-chip-${courierIdentifier}`,
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={onMenuClosed}
      >
        <MenuItem disabled>
          Courier : {courier?.name} ({courier?.id})
        </MenuItem>
        <MenuItem onClick={onReassignClicked} disableRipple>
          <FaRandom /> &nbsp; Assign to Active Partition
        </MenuItem>
        {onRemoveClicked && (
          <MenuItem onClick={onRemoveClicked} disableRipple>
            <FaTrash /> &nbsp; Remove from Partition
          </MenuItem>
        )}
        <MenuItem disableRipple>
          <FaMap /> &nbsp;{' '}
          <Link to={`/planner/preferred-areas/${courier?.id}`} target="_blank">
            Edit preferred areas
          </Link>
        </MenuItem>
      </Menu>
    </div>
  );
};
